import { useEffect, useState } from "react";

export default function usePWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  // Detect if app already installed
  const checkIfInstalled = () => {
    if (
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true || // iOS
      localStorage.getItem("pwa_installed") === "true"
    ) {
      setIsInstalled(true);
      setIsInstallable(false);
      return true;
    }
    return false;
  };

  useEffect(() => {
    // Check install state on mount
    checkIfInstalled();

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();

      if (checkIfInstalled()) {
        console.log("🚫 App already installed, skipping install prompt.");
        return;
      }

      setDeferredPrompt(e);
      setIsInstallable(true);
    };

    const handleAppInstalled = () => {
      console.log("✅ App installed successfully!");
      localStorage.setItem("pwa_installed", "true");
      setIsInstalled(true);
      setIsInstallable(false);
      setDeferredPrompt(null);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  const promptInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();

    const { outcome } = await deferredPrompt.userChoice;
    console.log("User response:", outcome);

    if (outcome === "accepted") {
      localStorage.setItem("pwa_installed", "true");
      setIsInstalled(true);
      setIsInstallable(false);
    }

    setDeferredPrompt(null);
  };

  return {
    isInstallable,
    isInstalled,
    promptInstall,
  };
}